export default "__VITE_ASSET__DcGT88FI__"